import angular from 'angular';
import IFlowModelCommandData from '@Shared.Angular/@types/core/contracts/commands/modeler/flowModelCommandData';
import IModelerProcessDetailDto from '@Shared.Angular/@types/core/contracts/queryModel/modeler/modelerProcessDetailDto';
import FlowModelType from '@Shared.Angular/@types/core/contracts/constants/flowModelType';
import { Guid } from '@Shared.Angular/@types/guid';
import { Services } from '@Shared.Angular/@types/services';
import type { CreationHubFlowModelDetails } from '../runner.creation-hub/components/CreationHubFlowModelDetailsPanel';

export class CreationHubService {
  public static $inject = [
    'workflowModelFactory',
    'modelerApiService',
    'sessionService'
  ];

  constructor(
    private workflowModelFactory: Services.WorkflowModelFactory,
    private modelerApiService: Services.ModelerApiService,
    private sessionService: Services.SessionService
  ) {}

  public createDraftFlowModel(
    flowModelType: FlowModelType,
    details: CreationHubFlowModelDetails,
    isAiGenerated: boolean
  ): angular.IPromise<Guid> {
    return this.workflowModelFactory
      .createFlowModel(details.name, details.description)
      .then((workflow) => {
        workflow.flowModelType = flowModelType;
        workflow.categoryId = details.categoryId || null;
        workflow.processDetail = this.buildProcessDetail(details);

        const user = this.sessionService.getUser();
        const payload: IFlowModelCommandData = {
          id: workflow.id,
          flowModelType: workflow.flowModelType,
          name: workflow.name,
          description: workflow.description,
          customPlaceholder: workflow.customPlaceholder || '',
          category: workflow.category || '',
          categoryId: workflow.categoryId,
          active: workflow.active,
          flowSchema: workflow.flowSchema,
          createdById: workflow.createdById,
          businessId: workflow.businessId,
          currentUserId: user.id,
          lastModifiedById: workflow.lastModifiedById || user.id,
          businessName: workflow.businessName || '',
          createdDate: workflow.createdDate,
          updatedDate: workflow.updatedDate,
          backgroundColour: workflow.backgroundColour || null,
          nodes: workflow.nodes as any,
          processDetail: workflow.processDetail,
          tags: [],
          isAiGenerated: isAiGenerated
        };

        return this.modelerApiService
          .addWorkflow(payload)
          .then((response) => response.data.id);
      });
  }

  private buildProcessDetail(
    details: CreationHubFlowModelDetails
  ): IModelerProcessDetailDto {
    return {
      id: null,
      objective: details.objective || '',
      background: details.background || '',
      processInput: details.processInput || '',
      processOutput: details.processOutput || '',
      triggerInput: details.triggerInput || '',
      processOwner: null
    };
  }
}

angular
  .module('flowingly.runner.services')
  .service('creationHubService', CreationHubService);

export type CreationHubServiceType = InstanceType<typeof CreationHubService>;
